import { useIsWidget } from '@app/hooks';

export const useUrlWithPrefix = (external = false) => {
  const isWidget = useIsWidget();

  return (url: string) => {
    const href =
      !external && isWidget
        ? `${window.REACT_APP_VKHRTEK_WIDGET_STATIC_URL}${url}`
        : url;

    return isWidget ? { href } : { to: href };
  };
};
